export const APP_STARTED = 'APP_STARTED';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const INITIALIZE_CONFIG = 'INITIALIZE_CONFIG';
export const QUERY_PARAM_TERM_UPDATED = 'QUERY_PARAM_TERM_UPDATED';
export const UPDATE_GATES = 'UPDATE_GATES';